var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "add-type",
    attrs: {
      title: (_vm.status === "edit" ? _vm.$t("编辑") : _vm.$t("添加")) + _vm.$t("类型"),
      visible: _vm.addVisible,
      width: 620
    },
    on: {
      cancel: _vm.closeAddVisible
    }
  }, [_c("a-form-model", {
    ref: "addFormRef",
    attrs: {
      model: _vm.addForm,
      rules: _vm.ADD_RULES,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_vm.ident ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("上级类型")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true,
      allowClear: ""
    },
    model: {
      value: _vm.addForm.parent,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "parent", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.parent"
    }
  })], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("理赔类型"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "name", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("类型说明"),
      prop: "description"
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: ""
    },
    model: {
      value: _vm.addForm.description,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "description", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.description"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("排序"),
      prop: "sort"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      min: 0
    },
    model: {
      value: _vm.addForm.sort,
      callback: function ($$v) {
        _vm.$set(_vm.addForm, "sort", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "addForm.sort"
    }
  })], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      size: "small"
    },
    on: {
      click: _vm.saveAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]), _vm.status === "add" && _vm.isContinue ? _c("a-checkbox", {
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: _vm.onContinueToAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")))]) : _vm._e()], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };